import { Actor, CollisionType } from "excalibur";
import { goToScene } from "../main";

export default class Computer extends Actor {
  constructor() {
    super({
      x: 3 * 16 + 8,
      y: 4 * 16 + 8,
      radius: 5,
      collisionType: CollisionType.Fixed,
      name: "computerContainer",
    });
    this.indicationShowing = false;
    this.computerCollider = new Actor({
      width: 24,
      height: 16,
      collisionType: CollisionType.Passive,
      name: "computerCollider",
    });
    this.addChild(this.computerCollider);
    this.computerCollider.on("collisionstart", (e) => {
      if (!this.indicationShowing && e.other.owner.name === "player") {
        this.createNotification();
      }
    });
    this.computerCollider.on("collisionend", () => {
      if (this.indicationShowing) {
        this.destroyNotification();
      }
    });
  }
  createNotification() {
    this.indicationShowing = true;
    this.noti = document.getElementById("hive-indication");
    this.noti.style.bottom = 0;
    this.noti.style.height = "60px";
    this.noti.style.padding = "10px";
    this.noti.style.display = "block";
    this.noti.innerHTML = `<p id="notification">SPACE: Online Menu</p>`;
  }
  destroyNotification() {
    this.indicationShowing = false;
    this.noti.innerHTML = ``;
    this.noti.style.bottom = "-400px";
    this.noti.style.padding = "0";
    this.noti.style.display = "none";
  }
  onInitialize() {}
}
